import Image from "next/image";
import React, { useState } from "react";
import { useTranslations } from "next-intl";

interface Time {
  time_id: number;
  price: number;
  time: string;
}

interface TicketDate {
  subtag_id: number;
  date: string;
  ticket_price: string;
  tag_id: number;
  tiems: Time[];
}

interface SelectTicketDateProps {
  ticketDates: TicketDate[];
  onDateSelect: (date: TicketDate) => void;
  onContinue: () => void;
  onTimeSelect: any;
  time: string;
}

const SelectTicketDate: React.FC<SelectTicketDateProps> = ({
  ticketDates,
  onDateSelect,
  onTimeSelect,
  onContinue,
  time,
}) => {
  const t = useTranslations("selectTicketDate");
  const [selectedDate, setSelectedDate] = useState<TicketDate | null>(null);
  const [rialIcon, setRialIcon] = useState("/rial.svg");
  const handleDateSelect = (date: TicketDate) => {
    setSelectedDate(date);
    onDateSelect(date);
    setRialIcon("/white rial.svg");
    if (date.tiems.length === 1) {
      onTimeSelect(date?.tiems[0]?.time_id);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="glass-effect border border-[#d9ac4f]/30 rounded-[40px] py-12 px-16 w-full max-w-[880px] mx-4">
        <h2 className="text-2xl font-bold text-center mb-10 ">
          {t("title")}
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 mb-10">
          {ticketDates?.map((date) => {
            return (
              <button
                key={date?.subtag_id}
                onClick={() => handleDateSelect(date)}
                className={`flex flex-col items-center p-4 rounded-lg border transition-all ${selectedDate?.subtag_id === date?.subtag_id
                  ? "bg-[#d9ac4f] text-[#D1D3D4] border-[#d9ac4fCC]"
                  : "glass-effect text-[#D1D3D4] border-[#d9ac4fCC] "
                  }`}
              >
                <div className=" font-medium mb-3">
                  {date?.date?.split(" ")?.[1]}
                </div>
                <div className="font-extrabold mb-3">{`${date?.date?.split(" ")?.[1]
                  } ${date?.date?.split(" ")?.[2]}`}</div>
                <div className="flex flex-col gap-1 justify-center items-center">
                  <span className="text-sm">{`${t("startingFrom")}`}</span>
                  <div className="flex items-center gap-1" dir="ltr">

                    <Image
                      src={`${rialIcon}`}
                      alt="rial"
                      className="mb-1"
                      width={15}
                      height={15}
                    />
                    <span className="text-sm">{`${date?.ticket_price}`}</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {selectedDate && (
          <div className="flex flex-col gap-2 mb-10">
            <span
              className={selectedDate.tiems.length > 1 ? "block" : "hidden"}
            >
              {t("pleaseSelectTime")}
            </span>
            {selectedDate.tiems.map((el) => {
              return (
                <div
                  key={el.time}
                  onClick={() => {
                    onTimeSelect(el.time_id);
                  }}
                  className={
                    +time === el.time_id
                      ? "bg-amber-50 border-dashed border-2 flex justify-between items-center border-amber-50 scale-[101%] p-4 cursor-pointer rounded-lg"
                      : "glass-effect border-dashed border-2 flex justify-between items-center border-[#d9ac4f] p-4 cursor-pointer rounded-lg"
                  }
                >
                  <div className="flex items-center gap-2">
                    {+time === el.time_id ? (
                      <span className="w-6 h-6 flex items-center justify-center rounded-full glass-effect border text-[#D1D3D4]">
                        <Image
                          src="/selected ticket.svg"
                          alt="selected"
                          width={30}
                          height={30}
                        />
                      </span>
                    ) : (
                      <span className="w-6 h-6 flex items-center justify-center  rounded-full bg-amber-400 text-[#D1D3D4]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                    )}

                    <span className="text-[#d9ac4f] lg:text-[16px] text-[12px] md:w-full w-9/12">
                      {t("eventBookingEntry")} {el.time}
                    </span>
                  </div>
                  <div className="flex gap-1 justify-center items-center" dir="ltr">
                    <Image
                      src={"/rial.svg"}
                      alt="rial"
                      className="mb-1"
                      width={15}
                      height={15}
                    />
                    <span className="text-sm">{el.price}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <button
          onClick={onContinue}
          disabled={!selectedDate}
          className={`w-full py-4 rounded-lg text-[#D1D3D4] font-medium transition-all ${selectedDate ? "bg-[#d9ac4f]" : "bg-[#d9ac4f66] cursor-not-allowed"
            }`}
        >
          {t("continue")}
        </button>
      </div>
    </div>
  );
};

export default SelectTicketDate;
